<template>
  <div class="modal_wrapper" :style="{backgroundColor: backgroundColor}">
    <div class="container">
      <div class="modal_container">
        <div class="modal_header">
          <img :src="info" height="25px" />
          {{ title }}
        </div>
        <div class="modal_body">
          <div class="body">
            <valueLabelSection :titleLabel="contentTitle"></valueLabelSection>
            <div class="confirm_content">
              <contractInfo></contractInfo>
              <tenantInfo :showPasswordLabel="true"></tenantInfo>
              <tenantOptionInfo
                :showInitLoginPasswordLabel="true"
              ></tenantOptionInfo>
            </div>
          </div>
          <div class="modal_buttons">
            <input
              type="button"
              :value="cancelButton"
              class="cancel_button"
              @click="$emit('close')"
            />
            <input
              type="button"
              :value="okButton"
              class="finish_button"
              @click="$emit('ok')"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import contractInfo from '../CorporationView/corporationComponents/contractInfo.vue'
import tenantInfo from '../CorporationView/corporationComponents/tenantInfo.vue'
import tenantOptionInfo from '../CorporationView/corporationComponents/tenantOptionInfo.vue'
import valueLabelSection from './modalwindowComponents/valueLabelSection.vue'

export default {
  data() {
    return {
      info: require('../../../../img/info.png'),
      title: 'テナント登録内容確認',
      contentTitle: '以下の内容でテナントを登録してもよろしいですか？',
      cancelButton: 'キャンセル',
      okButton: '登録'
    }
  },
  components: {
    valueLabelSection,
    contractInfo,
    tenantInfo,
    tenantOptionInfo
  },
  computed: {
    backgroundColor() {
      if (
        this.showCompleteModal === true ||
        this.showConfirmModal === true ||
        this.showFailureModal === true
      ) {
        return ''
      } else {
        return 'rgba(0, 0, 0, .5)'
      }
    }
  },
  methods: {}
}
</script>
<style scoped>
.container {
  display: table-cell;
  vertical-align: middle;
}
.body {
  width: 100%;
  height: 391px;
  padding-top: 40px;
}
.modal_container {
  height: 485px;
}
.contract_info,
.tenant_info,
.tenant_option_info {
  padding: 0;
  width: auto;
  height: auto;
  float: none;
}
.modal_header {
  background-color: #33ccff;
}
.contract_info_area,
.tenant_info_area,
.tenant_option_info_area {
  display: flex;
  padding-bottom: 20px;
  flex-flow: column;
}
</style>
<style>
.edit_area_half {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/modalWindow/confirmCorporationInfoModalWindow.vue